// types
import { i18nDispatcherProductionPlanning } from 'models/i18n';
import {
  MarketPeriodsType,
  MetricValueType,
  PlanRevisionStatus
} from 'utils/constants';
import { DailyDiagramValidationReason } from 'models/dispatcher';

// ==============================|| I18N SK USERS ||============================== //

const skDispatcherProductionPlanning: i18nDispatcherProductionPlanning = {
  title: 'Plánovanie produkcie',
  csvPrefix: 'BS',
  businessDay: {
    title: 'Obchodný deň',
    step01: 'Uzávierka príjmu',
    step02: 'Vyhodnotenie',
    step03: 'Uzávierka'
  },
  systemValues: {
    title: 'Systémové veličiny',
    [MetricValueType.price15mD1]: 'Predikovaná cena IDM15',
    [MetricValueType.price60mD1]: 'Predikovaná cena IDM60',
    [MetricValueType.priceDamD1]: 'Predikovaná cena DAM',
    [MetricValueType.predictionSystemImbalanceD1]:
      'Predikovaná odchýlka sústavy',
    price: '€/MWh',
    imbalance: 'MWh'
  },
  balanceGroupDiagram: {
    title: 'Plánovaná produkcia bilančnej skupiny',
    [MetricValueType.energyProdNomination]: 'Nominácia',
    [MetricValueType.predProdEnergyProdD1]: 'Predikovaná nominácia',
    [MetricValueType.energyProdSummaryProduction]: 'Sumárna produkcia',
    [MetricValueType.currentImbalanceD1]: 'Odchýlka bilančnej skupiny',
    [MetricValueType.plannedImbalanceD1]:
      'Plánovaná odchýlka bilančnej skupiny',
    [MetricValueType.plannedImbalancePrice]:
      'Predikované nacenenie plánovanej odchýlky'
  },
  productionPlan: {
    productionPlanTitle: 'Plán produkcie',
    consumptionPlanTitle: 'Plán spotreby',
    revisionNr: 'Revizia ',
    productionPlanPeriodDuration: {
      [MarketPeriodsType.MARKET_PERIODS]: 'Obchodná perióda',
      [MarketPeriodsType.MARKET_HOURS]: 'Hodina'
    },
    changeNominationToSummaryProduction:
      'Zmeniť nomináciu na sumárnu produkciu',
    nomination: 'Nominácia',
    productionSummary: 'Sumárna produkcia',
    revisionHistory: 'História revízií',
    sendToOKTE: 'Odoslať na OKTE',
    showPrediction: 'Zobraziť predikciu',
    deviceProductionPlan: {
      confirm: 'Potvrdiť',
      edit: 'Zmeniť',
      propagate: 'Propagovať',
      showRevisionHistory: 'Zobraziť históriu revízií',
      columns: {
        productionPlan: 'Plán produkcie',
        requestedProduction: 'Požadovaná produkcia',
        predictedProduction: 'Predikcia produkcie'
      }
    },
    [MetricValueType.predProdEndOfPeriodSocD1]:
      'Predikcia stavu nabitia batérie na konci periódy',
    [MetricValueType.predProdEndOfPeriodEnergyStoredD1]:
      'Predikcia uloženej energie',
    [MetricValueType.predProdEndOfPeriodFreeCapacityD1]:
      'Predikcia voľnej kapacity',
    [MetricValueType.predProdEnergyProdD1]: 'Predikcia produkcie',
    [MetricValueType.predProdEndOfPeriodPowerD1]:
      'Hodnota výkonu na konci periódy'
  },
  productionPlanRevisionStatus: {
    [PlanRevisionStatus.DRAFT]: 'Rozpracovaná',
    [PlanRevisionStatus.CONFIRMED]: 'Potvrdená',
    [PlanRevisionStatus.PROPAGATED]: 'Propagovaná',
    [PlanRevisionStatus.PLANNED]: 'Naplánovaná',
    [PlanRevisionStatus.REJECTED]: 'Zamietnutá',
    [PlanRevisionStatus.NEW]: '-',
    [PlanRevisionStatus.ACCEPTED]: 'Akceptovaná'
  },
  dailyDiagram: {
    createDailyNomination: 'Vytvoriť dennú nomináciu',
    updateDailyNomination: 'Aktualizovať dennú nomináciu',
    acceptDailyNomination: 'Akceptovať dennú nomináciu',
    showHistoryOfDailyNomination: 'Zobraziť históriu dennej nominacie',
    historyOfDailyNomination: 'História dennej nominacie'
  },
  revision: {
    revision: 'Revízia',
    status: 'Stav',
    totalProduction: 'Sumárna produkcia',
    createdBy: 'Autor',
    createdAt: 'Vytvorená',
    revisionHistory: 'História revízií',
    currentRevision: 'Aktuálna',
    copyRevision: 'Kopírovať plán produkcie zariadenia',
    copyRevisionDescription:
      'Vyberte dátum alebo rozpätie dátumov v budúcnosti, na ktoré chcete plán produkcie kopírovať',
    confirmCopy: 'Kopírovať plán produkcie zariadenia',
    confirmCopyRevision: 'Aplikovať plán produkcie zariadenia',
    confirmApply: 'Naozaj chcete aplikovať plán produkcie na vybrané dni?',
    confirmRevision: 'Potvrdiť plán produkcie zariadenia',
    confirmConfirm: 'Naozaj chcete potvrdiť plán produkcie zariadenia ',
    propagateRevision: 'Propagovať plán produkcie zariadenia',
    confirmPropagate: 'Naozaj chcete propagovať plán produkcie zariadenia '
  },
  activityLog: {
    title: 'História aktivít'
  },
  input: {
    filter: 'Filter'
  },
  validation: {
    [DailyDiagramValidationReason.MISSING_PRODUCTION_PLAN_REVISION]:
      'Pre zariadenie <DeviceName>{{deviceName}}</DeviceName> existuje revízia plánu produkcie, ktorá nie je zahrnutá v dennom diagrame.',
    [DailyDiagramValidationReason.PRODUCTION_PLAN_REVISION_OUT_OF_DAILY_DIAGRAM]:
      'Pre zariadenie <DeviceName>{{deviceName}}</DeviceName> existuje novšia revízia plánu produkcie. Pred pokračovaním aktualizujte denný diagram.',
    [DailyDiagramValidationReason.PRODUCTION_PLAN_REVISION_IN_DRAFT_STATE]:
      'Revízia denného diagramu obsahuje rozpracovanú revíziu plánu produkcie zariadenia <DeviceName>{{deviceName}}</DeviceName>.',
    [DailyDiagramValidationReason.NEWER_REVISION_FOR_DRAFT_PRODUCTION_PLAN_REVISION_EXISTS]:
      'Denný diagram obsahuje rozpracovanú revíziu plánu produkcie zariadenia <DeviceName>{{deviceName}}</DeviceName>. Pre toto zariadenie existuje novšia revízia, prosím, zaktualizujte denný diagram.'
  }
};

export default skDispatcherProductionPlanning;
